module.exports = __webpack_public_path__ + "static/media/2019_IMG_9620.ba6f82d9.jpg";